export const getAppliedFilterCount = (appliedForm = {}, formConfig = []) => {
  if (!formConfig.length) return 0;

  return formConfig.reduce((count, field) => {
    const value = appliedForm[field.formKey];

    // ignore undefined / null
    if (value === undefined || value === null) return count;

    // multi-select
    if (Array.isArray(value)) {
      return value.length > 0 ? count + 1 : count;
    }

    // string (text / select / date)
    if (typeof value === "string") {
      return value.trim() !== "" ? count + 1 : count;
    }

    // number / boolean (valid filter)
    return count + 1;
  }, 0);
};
